import { render } from "./page3.vue?vue&type=template&id=3a83edf8&scoped=true"
import script from "./page3.vue?vue&type=script&lang=js"
export * from "./page3.vue?vue&type=script&lang=js"

import "./page3.vue?vue&type=style&index=0&id=3a83edf8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a83edf8"]])

export default __exports__